import {CellType} from '../types';

export function isNumericType(type: string): type is CellType.Numeric {
	return type === CellType.Numeric;
}
